import React from 'react';
import PropTypes from 'prop-types';
import styles from './AuthForm.module.scss';

export const FormItem = ({ children }) => (
  <div className={styles.item}>{children}</div>
);

FormItem.propTypes = {
  children: PropTypes.node,
};

FormItem.defaultProps = {
  children: null,
};
